import { gql } from "@apollo/client";

import { MeetingsOverviewMeeting } from "./meetings-overview-meeting-fragment";

export default gql`
  ${MeetingsOverviewMeeting}
  query getUnscheduledMeetingsQuery($forUserId: Int!) {
    unscheduledMeetings: calendar(
      forUserId: $forUserId
      unscheduled: true
      isFinalized: false
    ) {
      totalCount
      edges {
        node {
          id
          meeting {
            ...MeetingsOverviewMeeting
          }
        }
      }
    }
  }
`;
